import { Component, OnInit, Input, ViewChild, Injector } from '@angular/core';
import { Product, ProductSearchRequest } from 'src/app/models/product';
import { ProductService } from 'src/app/services/product.service';
import { CartService } from 'src/app/services/cart.service';
import { Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, tap, switchMap, catchError } from 'rxjs/operators';
import { BaseResponse } from 'src/app/models/base-response';
import { ProductSuccessAddComponent } from '../product-success-add/product-success-add.component';
import { Cart, InvalidProduct } from 'src/app/models/cart';
import { AlertComponent } from 'src/app/alert/alert.component';
import { AdminHeaderComponent } from 'src/app/layouts/admin-header/admin-header.component';
import { ProductSuccessUploadComponent } from '../product-success-upload/product-success-upload.component';
import * as firebase from 'firebase';
import * as fileSaver from 'file-saver';
import { formatDate } from '@angular/common';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';

declare var $: any;

@Component({
  selector: 'app-add-product',
  templateUrl: './add-product.component.html',
  styleUrls: ['./add-product.component.css']
})
export class AddProductComponent implements OnInit {
  public keywordSearchText = '';
  public productSearchQueryParam: ProductSearchRequest = new ProductSearchRequest();
  public product: Product = null;
  public totalPrice: number;
  public searching = false;
  public searchFailed = false;
  public quantity = 0;
  public model: any;
  public cart: Cart[] = [];
  public invalidProduct: InvalidProduct[] = [];
  public fileName = '';
  public fileSize = 0;
  public filepath;

  @ViewChild('addToCartModal') addToCartModal: ProductSuccessAddComponent;
  @ViewChild('uploadOrderModal') uploadOrderModal: ProductSuccessUploadComponent;
  @ViewChild('alertComponent') alertModal: AlertComponent;
  @ViewChild(AdminHeaderComponent) header: AdminHeaderComponent;

  isLoadingProduct = false;
  expireDate = '';

  constructor(
    public productService: ProductService,
    private cartService: CartService,
    private router: Router,
    private authService: AuthenticationService
  ) {
    window.scrollTo(0, 0);
  }

  ngOnInit() {
    firebase.analytics().logEvent('pesan_buatpesanan_page');

    $(document).keydown(function (e) {
      if ($('[id*=ngb-typeahead]').length) {
        const $scrollable = $('[id*=ngb-typeahead]');
        const scrollTop = $scrollable.scrollTop();

        if (e.which === 38) {
          $scrollable.scrollTop(scrollTop - 25);
        } else if (e.which === 40) {
          $scrollable.scrollTop(scrollTop + 25);
        }
      }
    });

    $('body').on('keypress', 'input[type=number][maxlength]', function (event) {
      var key = event.keyCode || event.charCode;
      var txtVal = $(this).val();
      var maxlength = $(this).attr('maxlength');
      if (key > 31 && (key < 48 || key > 57)) {
        return false;
      }
      if (txtVal.length == maxlength) {
        event.preventDefault();
        return false;
      }
      return true;
    });

    $('body').on('paste', 'input[type=number][maxlength]', function (event) {
      return false;
    });
  }

  onSelectedItem(textValue: any): void {
    this.keywordSearchText = textValue.item.code;
    this.product = textValue.item;
    this.quantity = 1;
    this.product.ref_quantity = 1;
    this.getProduct();
    this.getExpireDateProduct();

    this.isLoadingProduct = true;
  }

  search = (text$: Observable<string>) =>
    text$.pipe(
      tap(() => this.isLoadingProduct = true),
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term =>
        this.productService.get(`/product/plain?src=${this.keywordSearchText}`).pipe(
          tap(() => this.searchFailed = false),
          catchError((err) => {
            this.searchFailed = true;
            this.isLoadingProduct = false;
            return of([]);
          }))
      ),
      tap<BaseResponse>(() => this.searching = false),
      map((data) => {
        this.isLoadingProduct = false;
        if (data.data.length === 0) {
          this.product = null;
          this.quantity = 0;
          this.expireDate = null;
        } else {
          const item = [];
          data.data.forEach(element => {
            item.push({
              code: element.code,
              name: element.name,
              product_category: element.product_category,
              unit_of_measure: element.uom,
              ref_quantity: 0
            });
          });

          return item;
        }
      })
    )

  formatter = (x: { name: string }) => x.name;

  getProduct(): void {
    this.productService.getPriceProduct(this.product.code, this.product.unit_of_measure,
      (data) => {
        if (data !== 0) {
          this.product.estimate_price = data;

          this.loadStock();
          this.isLoadingProduct = false;
        } else {
          this.alertModal.show('', `Hasil pencarian tidak ditemukan.`);
          this.isLoadingProduct = false;
          this.keywordSearchText = null;
          this.product = null;
          this.quantity = 0;
          this.expireDate = null;
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  loadStock() {
    this.productService.getProductStock(this.product.code, this.product.unit_of_measure,
      resp => {
        if (resp.alert.code === 200) {
          this.product.estimate_stock = resp.data;
        }
      },
      err => {
        console.log(err);
      });
  }

  onEnter(): void {
    if (this.keywordSearchText.length >= 3) {
      this.getProduct();
      this.isLoadingProduct = true;
    }
  }

  public addToCart(product: Product): void {
    if (product && product.ref_quantity > 0) {
      firebase.analytics().logEvent('keranjang_add_to_cart_button');

      this.cartService.addToCart(product.code, product.unit_of_measure, product.ref_quantity, product.product_category,
        (data) => {
          this.addToCartModal.showWithData(product, true);
          this.header.loadCart();

          this.keywordSearchText = null;
          this.product = null;
          this.quantity = 0;
          this.expireDate = null;
        },
        (err) => {
          this.keywordSearchText = null;
          this.product = null;
          this.quantity = 0;
          this.expireDate = null;

          if (err.code === 417) {
            return;
          }

          this.addToCartModal.showWithData(product, false, err);
        });
    } else {
      if (this.product) {
        this.product.alert_message = 'Masukkan jumlah pesanan terlebih dahulu';
      }
    }
  }

  onChangeQuantity(): void {
    this.productService.insertQuantity(this.quantity, this.product);
  }

  onFileChanged(files: FileList): void {
    firebase.analytics().logEvent('order_upload_excel_button');

    this.uploadOrderModal.showLoader();
    this.invalidProduct = null;

    if (files.length > 0) {
      const file = files.item(0);

      this.productService.uploadExcel(file,
        (data) => {
          this.header.loadCart();

          this.invalidProduct = data.list_invalid;
          this.uploadOrderModal.showWithData(this.invalidProduct, true);
        },
        (err) => {
          if (err.code === 417) {
            setTimeout(() => {
              this.uploadOrderModal.removeLoader();
            }, 500);
            return;
          }

          this.uploadOrderModal.showWithData(this.invalidProduct, false);
        }
      );
    }

    $('#file-upload').val('');
  }

  public download() {
    this.productService.getTemplate(
      resp => {
        const fr = new FileReader();
        fr.readAsText(resp);
        fr.addEventListener("load", () => {
          const resp = fr.result;
          const parsed = JSON.parse(resp.toString());

          if (parsed && parsed.alert.code === 200) {
            fileSaver.saveAs(resp, 'aplezrx_upload.xlsx');
          } else {
            if (parsed && parsed.alert.code === 417) {
              this.authService.getGTStatus((resp) => {
                if (resp.alert.code == 200) {
                  $('#alert-top-message').html(parsed.alert.message);
                  $('#alert-top-modal').modal('show');
                  localStorage.setItem('topStatus', resp.data.isPBD2);
                  localStorage.setItem('gtStatus', resp.data.isGeneralTrade);
                }
              }, () => {
                localStorage.clear();
                this.router.navigate(['/']);
              });
            } else {
              this.alertModal.show(parsed.alert.code, parsed.alert.message);
            }
          }
        }, false);
      },
      err => {
        console.log(err);
      });
  }

  public updateQuantity(type: boolean): void {
    if (type) {
      if (this.product.ref_quantity < 9999) {
        this.product.ref_quantity += 1;
        this.quantity += 1;
      }
    } else {
      if (this.product.ref_quantity > 1) {
        this.product.ref_quantity -= 1;
        this.quantity -= 1;
      }
    }
  }

  // CR-15
  getExpireDateProduct(): void {
    let productCode = [];
    productCode.push(this.product.code);

    const param = {
      productCode: productCode
    };

    this.productService.getExpireDateProduct(param,
      (data) => {
        if (data[0].bathcEd === '0') {
          this.expireDate = '-';
        } else {
          this.expireDate = formatDate(data[0].bathcEd, 'dd MMMM yyyy', 'id');
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }
}
